import { ICheckboxMultiSelectOption } from '@app/ui/checkbox-multi-select/checkbox-multi-select.component';

export class PartialPlant implements ICheckboxMultiSelectOption {
  address1: string;
  colorId: number;
  color: string;
  divisionId: number;
  id: number;
  inactiveFlag: boolean;
  latitude: string;
  longitude: string;
  name: string;
  printTicketMethod: number;
  systemType: number;
  useBatchPanelFlag: boolean;
  // for settings
  selected?: boolean;
  visible?: boolean;
  divisionAbbreviation?: string;

  get msoKey(): number {
    return this.id;
  }

  get msoDescriptor(): string {
    return this.name;
  }

  get msoIsVisible(): boolean {
    return true;
  }
}
